import React, { PropsWithChildren, ReactNode } from 'react';
import { Stack } from '../stack';
import { IconArrowChevronLeft } from '../icons/generated';
import { semantic_colors } from '../../foundation';
import { CloseButton } from '../button';
import styled from '@emotion/styled';
import { BaseText } from '../text';
import { useProviderConfig } from '../provider';
import { buildCSSWithLength } from '../../styles';

export interface ModalHeaderProps {
  title?: ReactNode;
  /**
   * 헤더 영역 타이틀 좌측 backButton 사용 유무
   * @default false
   */
  backButton?: boolean;
  /** @default true */
  closeButton?: boolean;
  /**
   * reason을 포함한 cancel 이벤트를 전달합니다.
   *  - 'cancelClick' | 'escapeKeyPress' | 'overlayClick'
   */
  onCancel?: () => void;
  /**
   * Modal Header backButton 클릭 이벤트
   */
  onClickBackButton?: () => void;
}
export const ModalHeader = ({
  title,
  backButton = false,
  closeButton = true,
  onCancel,
  onClickBackButton,
}: PropsWithChildren<ModalHeaderProps>) => {
  const { locale } = useProviderConfig();

  if (!title && !backButton && !closeButton) {
    return null;
  }

  return (
    <Stack direction='column' width='100%'>
      <Stack direction='row' width='100%' gap={8} align='center'>
        {backButton && (
          <Stack direction='row'>
            <ModalButton type='button' size={20} aria-label={locale?.accessibility.back} onClick={onClickBackButton}>
              <IconArrowChevronLeft size={20} />
            </ModalButton>
          </Stack>
        )}
        <ModalTitle typography='Heading_17_Bold' color={semantic_colors.content.primary}>
          {title}
        </ModalTitle>
        {closeButton && (
          <Stack direction='row' ml='auto'>
            <CloseButton size={20} onClick={() => onCancel?.()} color={semantic_colors.content.primary} />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

const ModalTitle = styled(BaseText)`
  width: 100%;
  overflow: hidden;
`;

const ModalButton = styled.button<{ size: number }>`
  ${({ size }) =>
    size &&
    `
      ${buildCSSWithLength('width', size)};
      ${buildCSSWithLength('height', size)};
  `};
  padding: 0;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
`;
